import axios from 'axios'
import Utils from '@/common/utils';

export default {
  search: function (request) {
    if(request.male == 1) {
      request.male = null
    }
    if(request.hasImar == 1) {
      request.hasImar = null
    }
    return axios.get('/api/journal/search', { params: request })
  },
  exportFile: function (request) {
    const params = { ...request };
    if (params.male == 1) params.male = null;
    if (params.hasImar == 1) params.hasImar = null;
    return Utils.downloadFile('/api/journal/exportExcel', 'DnevnikLRAS.xlsx', params);
  },
  getNsi: function(dictName, request) {
    return axios.get('/api/nsi/' + dictName, { params: request })
  },
  find: function (id, config = {}) {
    return axios.get('/api/journal/find?id='+id, config)
  },
  getById: function (id) {
    return axios.get('/api/journal/getById?id='+id)
  },
  save: function (data) {
    return axios.post('/api/journal/save', data)
  },
  saveRoute: function (data) {
    return axios.post('/api/journalroute/save', data)
  },
}
